import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ArrowHorizontal({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ArrowHorizontal</title>
      <path
        d="M20 12L4 12M20 12L16.5 15.5M20 12L16.5 8.5M4 12L7.5 8.5M4 12L7.5 15.5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
